import startCase from 'lodash/startCase';

import { readableSingularSegmentType } from '~/lib/segments';

export function destinationNameForType(destinationType) {
  switch (destinationType) {
    case destinationTypeCustomHtml:
      return 'Custom HTML';
    case destinationTypeEmail:
      return 'Email digest';
    default:
      return startCase(destinationType);
  }
}

export function shortDescriptionForType(destinationType) {
  switch (destinationType) {
    case destinationTypeEmail:
      return 'Send matches via scheduled emails';
    case destinationTypeSalesforce:
      return 'Post to Chatter or create new Tasks';
    case destinationTypeSlack:
      return 'Send messages to Slack channels';
    case destinationTypeWebhook:
      return 'Post new matches to webhook URLs';
    case destinationTypeCustomHtml:
      return 'Trigger HTML/JS on segment match';
    default:
      return startCase(destinationType);
  }
}

export function destinationSubtitleForType(
  destinationType,
  typename,
  includeLink = true,
) {
  const segmentType = readableSingularSegmentType(typename);

  switch (destinationType) {
    case destinationTypeWebhook:
      return (
        <span>
          Post to a URL of your choice when a {segmentType} matches the segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360022031574-Webhook-Destination"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );
    case destinationTypeEmail:
      return (
        <span>
          Send a scheduled email with a CSV digest of{' '}
          {segmentType === 'person' ? 'people' : 'companies'} matching the
          segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360022232093-Email-Destination"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );
    case destinationTypeSlack:
      return (
        <span>
          Post to Slack when a {segmentType} matches the segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360022030174-Slack-Destination"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );
    case destinationTypeSalesforce:
      return (
        <span>
          Create a Salesforce Task or post to Chatter when a {segmentType}{' '}
          matches the segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360022031134-Salesforce-Destination"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );

    case destinationTypeCustomHtml:
      return (
        <span>
          Execute custom HTML/JS on your website when a visitor matches a
          segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360036261373-Custom-HTML-Destination-beta-"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );

    default:
  }
}

export const destinationTypeCustomHtml = 'custom_html';
export const destinationTypeEmail = 'email';
export const destinationTypeSalesforce = 'salesforce';
export const destinationTypeSlack = 'slack';
export const destinationTypeWebhook = 'webhook';

export const destinationTypes = [
  destinationTypeCustomHtml,
  destinationTypeEmail,
  destinationTypeSalesforce,
  destinationTypeSlack,
  destinationTypeWebhook,
];

export const alertDestinationTypes = [
  destinationTypeSlack,
  destinationTypeSalesforce,
  destinationTypeEmail,
  destinationTypeWebhook,
];

export const personalizationDestinationTypes = [destinationTypeCustomHtml];
